module.exports = __webpack_public_path__ + "static/media/Florencio Mazzoldi.e4e18459.png";